export interface AuthState {
    access_token: string;
    account: Account;
    credentials: Credential;
}

export interface Account {
    username: string;
    change_password: boolean;
    data: {
        first_name: string;
        last_name: string;
        email: string;
    };
    tokens: Array<Token>;
}

export interface Token {
    agent: string;
    last_login: number;
}

export interface Credential {
    google: string;
}

export default {
    namespaced: true,
    state: (): AuthState => ({
        access_token: undefined,
        account: undefined,
        credentials: undefined,
    }),
    getters: {
        getAccessToken(state) {
            return state.access_token;
        },
        getAccount(state) {
            return state.account;
        },
    },
    mutations: {
        setAccessToken(state, token) {
            state.access_token = token;
        },
        setAccount(state, account) {
            state.account = account;
        },
        setCredentials(state, credentials) {
            state.credentials = credentials;
        },
    },
    actions: {
        fetchAccount(state) {
            this._vm.axios
                .get("/account")
                .then((res) => state.commit("setAccount", res.data))
                .catch(() =>
                    state.commit("ui/logMessage", { logLevel: 0, message: "Die Account Daten konnten nicht geladen werden." }, { root: true })
                );
        },
    },
    modules: {},
};
